import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Container, Typography, Box } from '@mui/material';

import { SESSIONS_ROUTES } from '@constants';


export default function NotFoundPage() {
    const navigate = useNavigate()
    const handleLogout = () => {
        return navigate(SESSIONS_ROUTES.LOGOUT_URL, {replace: true})
    }
    return (
        <Container component="main" maxWidth="xs" style={{ textAlign: 'center', marginTop: '20vh' }}>
            <Typography variant="h1" component="h1" gutterBottom>
                404
            </Typography>
            <Typography variant="h5" component="h2" gutterBottom>
                Page Not Found
            </Typography>
            <Typography variant="body1" component="p" gutterBottom>
                The page you are looking for does not exist.
            </Typography>
            <Box mt={4}>
                <Button variant="contained" color="primary" onClick={handleLogout}>
                    Logout
                </Button>
            </Box>
        </Container>
    );
}
